// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mv6P","clinicsSelect":"styles_clinicsSelect__1X4jh"};